import React from 'react'
import { Accordion, Stack, Text, Title } from '@mantine/core'
import { useSmallerScreen } from 'hooks'
import { ContentContainer } from 'components/site'

import { faqList } from './constant'

const Faq = () => {
  const smallerScreen = useSmallerScreen()

  return (
    <ContentContainer className={smallerScreen ? 'py-[60px]' : 'py-[120px]'}>
      <Stack spacing={smallerScreen ? 24 : 48} align="center">
        <Title order={2} align="center" weight={900} className="xs:!text-[40px] !text-[28px]">
          常见问题
        </Title>
        <Accordion variant="separated" radius="md" className="w-full max-w-[800px]" defaultValue={faqList[0].question}>
          {faqList.map((item) => (
            <Accordion.Item key={item.question} value={item.question}>
              <Accordion.Control>
                <Text weight={600} size={smallerScreen ? 'md' : 'lg'}>
                  {item.question}
                </Text>
              </Accordion.Control>
              <Accordion.Panel>
                <Text color="gray.7" size={smallerScreen ? 'sm' : 'md'}>
                  {item.answer}
                </Text>
              </Accordion.Panel>
            </Accordion.Item>
          ))}
        </Accordion>
      </Stack>
    </ContentContainer>
  )
}

export default Faq
